import React, { useState } from 'react';
import { gql } from 'apollo-boost';

const moment = require("moment");


const renderStats = (users, transactions, payments) => {
  const totalTransactionVolume = transactions.reduce(
    (total, t) => (total += t.amount ? t.amount : 0),
    0,
  );
  const totalPaymentVolume = payments.reduce(
    (total, p) => (total += !['RETURNED','CANCELED'].includes(p.status) && p.amount ? p.amount : 0),
    0,
  );
  const totalLimit = users.reduce(
    (total, u) => (total += u.credit ? u.credit.credit_limit : 0),
    0,
  );
  return (
    <div>
      <div className="float-right mr-4">
        <a
          className="underline hover:text-green-primary"
          href="/dashboard/supportal"
        >
          Supportal, Go!
        </a>
      </div>
      <div>
        <div>Number of approved users: {users.length}</div>
        <div>Total limit: {totalLimit.toFixed(2)}</div>
      </div>
      <div>
        <div>Number of transactions: {transactions.length}</div>
        <div>Total Transaction Volume: {totalTransactionVolume.toFixed(2)}</div>
      </div>
      <div>
        <div>Number of payments: {payments.length}</div>
        <div>Total Payment Volume: {totalPaymentVolume.toFixed(2)}</div>
      </div>
    </div>
  );
};

const renderPageSelector = (users, transactions, payments, setPage, setPageList) => (
  <div className="mt-5">
    <span
      id="users"
      className="cursor-pointer p-2"
      onClick={e => handlePage(e.target.id, {users, transactions}, setPage, setPageList)}
    >
      Users ({users.length})
    </span>
    |
    <span
      id="transactions"
      className="cursor-pointer p-2"
      onClick={e => handlePage(e.target.id, transactions, setPage, setPageList)}
    >
      Transactions ({transactions.length})
    </span>
    |
    <span
      id="payments"
      className="cursor-pointer p-2"
      onClick={e => handlePage(e.target.id, payments, setPage, setPageList)}
    >
      Payments ({payments.length})
    </span>
    |
    <span
      id="fraud"
      className="cursor-pointer p-2"
      onClick={e => window.open('#/admin/god/fraud', "_blank")}
    >
      Fraud List
    </span>
  </div>
);

const filterData = (pg, items) => {
  switch (pg) {
    case 'users':
      return items;
    case 'transactions':
      return items;
    case 'payments':
      return items;
    default:
      return [];
  }
};

const handlePage = (pg, items, setPage, setPageList) => {
  setPage(pg);
  const filteredData = filterData(pg, items);
  if (pg === "transactions") {
    filteredData.sort((a, b) => moment(b.created_at) - moment(a.created_at));
  } else if (pg === "users") {
    filteredData.users.sort((a, b) => b.created_at - a.created_at);
  } else {
    filteredData.sort((a, b) => b.created_at - a.created_at);
  }
  setPageList(filteredData);
};

const GodView = () => {
  const [page, setPage] = useState("transactions");
  const [pageList, setPageList] = useState([]);

  return <>Site under maintenance. Please use direct url or redirect from supportal :(</>;
};

const QUERY = gql`
  query Activities {
    transactions(showAll: 1, api: "galileo") {
      description
      amount
      created_at
      status
      User {
        first_name
        last_name
        email
      }
    }
    payments(showAll: 1, api: "galileo") {
      amount
      created_at
      status
      category
      User {
        first_name
        last_name
        email
      }
    }
    users(status: "approved", api: "galileo") {
      email
      first_name
      last_name
      email
      last_activity_at
      total_spend
      credit {
        credit_limit
        credit_used
      }
      card {
        activated
      }
      id
    }
  }
`;

export default GodView;
